import React, {Component} from 'react';
import { Link } from "react-router-dom";

import './Modal.css';

export default class Modal extends Component {
    render() {
        return (
            <div className="modal visible" data-content-name="request">
                <div className="content">
                    <h2>Request an icon</h2>
                    <Link className="close" to="/">Close popup</Link>
                    <p>Softies is constantly being updated. If you have any suggestions for icons you'd like me to add, then please <a href="mailto:hi@robbiepearce.com?subject=Softies Request">email me</a>. They might just get made!</p>
                    <p>Please note: Softies is maintained in my free time, so I cannot promise that requests will always make it into the set.</p>
                </div>
            </div>
        )
    }

}
